import { scrubPropertyTelemetry, shouldReportToSentry } from '@altsui/shared';
import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN;
const environment = import.meta.env.MODE;
const release = import.meta.env.VITE_SENTRY_RELEASE ?? import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA;

if (shouldReportToSentry({ dsn, environment, enableDev: import.meta.env.VITE_SENTRY_ENABLE_DEV })) {
  Sentry.init({
    dsn,
    beforeSend: event => scrubPropertyTelemetry(event),
    beforeSendTransaction: event => scrubPropertyTelemetry(event),
    beforeSendSpan: span => scrubPropertyTelemetry(span),
    beforeBreadcrumb: breadcrumb => scrubPropertyTelemetry(breadcrumb),
    environment,
    release,
    // Replay includes URL/DOM metadata beyond text masking. Property access
    // links are credentials, so do not collect or upload session recordings.
    integrations: [Sentry.browserTracingIntegration()],
    sendDefaultPii: false,
    tracesSampleRate: environment === 'production' ? 0.2 : 0,
  });
  Sentry.setTag('service', 'web');
}
